import React from "react";
import { Route, Routes } from "react-router-dom";

// redux
import { useSelector } from "react-redux";

// All layouts containers
import DefaultLayout from "../layouts/Default";
import VerticalLayout from "../layouts/Vertical";
import ProtectedRoute from "../components/ProtectedRoute";

import { authProtectedFlattenRoutes, publicProtectedFlattenRoutes } from ".";

const AllRoutes = (props) => {
  const { Layout } = useSelector((state) => ({
    Layout: state.Layout,
  }));

  return (
    <React.Fragment>
      <Routes>
        {(publicProtectedFlattenRoutes || []).map((route, idx) => (
          <Route
            path={route.path}
            element={
              <DefaultLayout {...props} layout={Layout}>
                {route.element}
              </DefaultLayout>
            }
            key={idx}
          />
        ))}

        {(authProtectedFlattenRoutes || []).map((route, idx) => {
          // Use the route's specified route component (PrivateRoute or PermissionRoute)
          // or fallback to ProtectedRoute
          const RouteGuard = route.route || ProtectedRoute;
          
          return (
            <Route
              path={route.path}
              element={
                <RouteGuard>
                  <VerticalLayout {...props}>{route.element}</VerticalLayout>
                </RouteGuard>
              }
              key={idx}
            />
          );
        })}
      </Routes>
    </React.Fragment>
  );
};

export default AllRoutes;
